import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import i18n from '../i18n';
import { useSelectArtikal } from '../store/index';

export const ScanedArtikal = (props) => {
    const showArtikalDialog = useSelectArtikal((state) => state.showArtikalDialog);
    const setShowArtikalDialog = useSelectArtikal((state) => state.setShowArtikalDialog);
    // const dialogCallback = useSelectArtikal((state) => state.dialogCallback);
    // const updateId = useSelectArtikal((state) => state.updateId);

    // const onRowDoubleClick = (e) => {
    //     // dialog callback je funkcija koja je prosledjena d strane akcije
    //     // koja je pokrenula ovaj dialog
    //     //setSelectedArtikal(e.data);
    //     setShowArtikalDialog(false);
    //     if (dialogCallback) {
    //         dialogCallback(e.data, updateId);
    //     }
    // };

    const footerContent = (
        <div className="flex justify-content-between w-full">
            <Button label={i18n.t('close')} icon="pi pi-times" outlined onClick={() => setShowArtikalDialog(false)} />
        </div>
    );

    return (
        <div>
            <Dialog
                header="Lista artikala"
                visible={showArtikalDialog}
                position="midle"
                style={{ width: '80vw', height: 'auto', minHeight: '60vh' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                modal
                onHide={() => {
                    if (!showArtikalDialog) return;
                    setShowArtikalDialog(false);
                }}
                footer={footerContent}
            >
                {/* <pre>{JSON.stringify(selectedDoc, false, 2)}</pre>
                 */}
            </Dialog>
        </div>
    );
};
